import { Tip } from './Guidance.types';

export const itemsObject: Tip[] = [
  {
    id: 'editMode',
    className: 'EditorMode-wrapper',
    title: 'Change to Material Mode',
    hotkeys: [['⌥', '+', '2']],
    position: 'left',
  },
  {
    id: 'randomize',
    className: 'Randomize-btn',
    title: 'Randomize the model',
    hotkeys: [
      ['⌥', '+', 'r'],
      ['⌥', '⇧', '+', 'r'],
    ],

    position: 'bottom right',
  },
  {
    id: 'wack',
    className: 'Wacom-wrapper',
    title: 'Wack modifiers',
    position: 'bottom left',
  },
  {
    id: 'parameters',
    className: 'bar-right',
    title: 'Change model with sliders and buttons',
    position: 'left',
  },
  {
    id: 'prompt',
    className: 'Prompter-wrapper',
    title: 'Change model with a prompt',
    position: 'top',
  },
  {
    id: 'holodeck',
    className: 'Holodeck-wrapper',
    title: 'Change the environment',
    position: 'top left',
  },
  {
    id: 'models',
    className: 'NavBarSwitcher-wrapper',
    title: 'Load another generator',
    position: 'right',
  },
  {
    id: 'lod',
    className: 'Lod-wrapper',
    title: 'Change LOD',
    position: 'top right',
  },
];

export const itemsMaterial: Tip[] = [
  {
    id: 'editMode',
    className: 'EditorMode-wrapper',
    title: 'Change to Shape Mode',
    hotkeys: [['⌥', '+', '1']],
    position: 'left',
  },
  {
    id: 'randomize',
    className: 'Randomize-btn',
    title: 'Randomize the materials',
    hotkeys: [
      ['⌥', '+', 'r'],
      ['⌥', '⇧', '+', 'r'],
    ],
    position: 'bottom right',
  },
  {
    id: 'prompt',
    className: 'Prompter-wrapper',
    title: 'Change materials with a prompt',
    position: 'top',
  },
  {
    id: 'holodeck',
    className: 'Holodeck-wrapper',
    title: 'Change the environment',
    position: 'top left',
  },
  {
    id: 'models',
    className: 'NavBarSwitcher-wrapper',
    title: 'Load another generator',
    position: 'top right',
  },
  {
    id: 'lod',
    className: 'Lod-wrapper',
    title: 'Change LOD',
    position: 'right',
  },
  {
    id: 'materials',
    className: 'bar-right',
    title: 'Play with the materials',
    position: 'left',
  },
];
